import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { PATH } from '../../constants/router'
import BaseButton from '../../components/BasicComponent/BaseButton'
import BaseTitle from '../../components/BasicComponent/BaseTitle'
import FixedBottom from '../../components/BasicComponent/FixedBottom'
import BaseInput from '../../components/BasicComponent/BaseInput'
import LayoutPartner from '../../components/FeaturesComponent/layoutPartner'
import { validatePhoneNumber } from '../../helper/common'
import { useAppUserContext } from '../../context/AppUserContext'
import imgPhoneAuth from '../../assets/images/automatedTrafficFineNotificationPhoneAuth.png'
import './index.scss'

import {
  IconAutomatedTrafficFineNotificationIntroduce1,
  IconAutomatedTrafficFineNotificationIntroduce2,
  IconAutomatedTrafficFineNotificationIntroduce4,
  IconAutomatedTrafficFineNotificationIntroduce5
} from '../../assets/icons'
import IconAutomatedTrafficFineNotificationIntroduce7 from '../../assets/icons/AutomatedTrafficFineNotificationIntroduce7.png'
import IconAutomatedTrafficFineNotificationIntroduce8 from '../../assets/icons/AutomatedTrafficFineNotificationIntroduce8.png'
import IconAutomatedTrafficFineNotificationIntroduce9 from '../../assets/icons/AutomatedTrafficFineNotificationIntroduce9.png'
import IconAutomatedTrafficFineNotificationIntroduce10 from '../../assets/icons/AutomatedTrafficFineNotificationIntroduce10.png'
import IconAutomatedTrafficFineNotificationIntroduce11 from '../../assets/icons/AutomatedTrafficFineNotificationIntroduce11.png'
import IconAutomatedTrafficFineNotificationIntroduce12 from '../../assets/icons/AutomatedTrafficFineNotificationIntroduce12.png'
import IconAutomatedTrafficFineNotificationIntroduce13 from '../../assets/icons/AutomatedTrafficFineNotificationIntroduce13.png'

export default function AutoTrafficFineNotificationPhoneAuth() {
  const history = useHistory()
  const { userData, setUserInfo } = useAppUserContext()

  const [phoneNumber, setPhoneNumber] = useState('')
  const [phoneError, setPhoneError] = useState('')
  const [isPhoneValid, setIsPhoneValid] = useState(false)

  // Auto-fill phone number from Context / LocalStorage on mount
  useEffect(() => {
    if (userData?.phoneNumberFromSdk) {
      const storedPhone = userData.phoneNumberFromSdk
      setPhoneNumber(storedPhone)
      const validation = validatePhoneNumber(storedPhone)
      setIsPhoneValid(validation.isValid)
    }
  }, [userData])

  const handlePhoneChange = (e) => {
    let value = e.target.value.replace(/[^0-9]/g, '')
    setPhoneNumber(value)

    const validation = validatePhoneNumber(value)
    setIsPhoneValid(validation.isValid)
    setPhoneError(validation.errorMessage)
  }

  const handleConfirm = () => {
    if (isPhoneValid) {
      setUserInfo({
        ...userData,
        phoneNumberFromSdk: phoneNumber
      })
      history.push(PATH.AUTO_TRAFFIC_FINE_NOTIFICATION_LOOKUP)
    }
  }

  const listDescription = [
    {
      icon: <img className="des_icon" src={IconAutomatedTrafficFineNotificationIntroduce10} alt="" />,
      text: 'Thông báo khi có vi phạm'
    },
    {
      icon: <img className="des_icon" src={IconAutomatedTrafficFineNotificationIntroduce11} alt="" />,
      text: 'Thông báo khi có vi phạm mới'
    },
    {
      icon: <IconAutomatedTrafficFineNotificationIntroduce1 className="des_icon" />,
      text: 'Thông báo phạt nguội'
    },
    {
      icon: <IconAutomatedTrafficFineNotificationIntroduce2 className="des_icon" />,
      text: 'Thông báo hạn đăng kiểm'
    },
    {
      icon: <IconAutomatedTrafficFineNotificationIntroduce4 className="des_icon" />,
      text: 'Ưu đãi 30% khi mua BH TNDS'
    },
    {
      icon: <img className="des_icon" src={IconAutomatedTrafficFineNotificationIntroduce12} alt="" />,
      text: 'Trợ lý tư vấn bảo hiểm'
    },
    {
      icon: <img className="des_icon" src={IconAutomatedTrafficFineNotificationIntroduce13} alt="" />,
      text: 'Trợ lý hỗ trợ thủ tục bảo hiểm'
    },
    {
      icon: <img className="des_icon" src={IconAutomatedTrafficFineNotificationIntroduce8} alt="" />,
      text: 'Hỗ trợ gói tín dụng chi phí giao thông'
    },
    {
      icon: <IconAutomatedTrafficFineNotificationIntroduce5 className="des_icon" />,
      text: 'Hỗ trợ tặng thẻ tín dụng ưu đãi'
    },
    {
      icon: <img className="des_icon" src={IconAutomatedTrafficFineNotificationIntroduce9} alt="" />,
      text: 'Hỗ trợ ưu đãi khi mua gói cứu hộ ô tô / xe máy'
    }
  ]

  return (
    <LayoutPartner blendHeaderWithBody={true}>
      <div className="AutoTrafficFineNotificationPhoneAuth">
        <div className="AutoTrafficFineNotificationPhoneAuth_img">
          <img src={imgPhoneAuth} alt="" />
        </div>
        
        <div className="AutoTrafficFineNotificationPhoneAuth_card">
          <div className="AutoTrafficFineNotificationPhoneAuth_title">Nhập số điện thoại</div>
          <div className="AutoTrafficFineNotificationPhoneAuth_subtitle">
            Nhập số điện thoại của bạn để tiếp tục tra cứu phạt nguội hoặc mua gói thông báo tự động.
          </div>
          <BaseInput
            type="tel"
            value={phoneNumber}
            onChange={handlePhoneChange}
            placeholder="Ví dụ: 0987654321"
            inputMode="numeric"
            maxLength="11"
            error={phoneError}
          />
        </div>

        <div className="AutoTrafficFineNotificationPhoneAuth_benefitsCard">
          <BaseTitle>Bạn sẽ nhận được</BaseTitle>
          <div className="AutoTrafficFineNotificationPhoneAuth_des">
            {listDescription.map((item, index) => (
              <div key={index} className="AutoTrafficFineNotificationPhoneAuth_des_item">
                {item.icon}
                <div className="des_text">{item.text}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <FixedBottom elementPaddingBottom={'LayoutPartner'}>
        <BaseButton onClick={handleConfirm} disabled={!isPhoneValid || !phoneNumber}>
          Xác nhận
        </BaseButton>
      </FixedBottom>
    </LayoutPartner>
  )
}
